import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import * as firebase from 'firebase'

Vue.config.productionTip = false;

const firebaseConfig = {
  apiKey: "AIzaSyCgjo-b4urbYjWDkueyoGY_hxDw5Q5-TDQ",
  authDomain: "limeboard-demo.firebaseapp.com",
  databaseURL: "https://limeboard-demo.firebaseio.com",
  projectId: "limeboard-demo",
  storageBucket: "limeboard-demo.appspot.com",
  messagingSenderId: "514465553317",
  appId: "1:514465553317:web:b36b5b6ee7ea9316b4a64c",
  measurementId: "G-7K7EF2XJLJ"
};
firebase.initializeApp(firebaseConfig);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
